import { PRODUCT_RAW_MATERIAL } from 'actionTypes';
import actionsFactory from 'utils/redux/baseEntitiesFactory/actions';
import reducerFactory from 'utils/redux/baseEntitiesFactory/reducer';
import sagasFactory from 'utils/redux/baseEntitiesFactory/sagas';
import thunkFactory from 'utils/redux/baseEntitiesFactory/thunk';

// ACTIONS
const rawActions = actionsFactory(PRODUCT_RAW_MATERIAL);
const actions = {
  ...rawActions,
  ...thunkFactory(PRODUCT_RAW_MATERIAL, '/produto_mp/'),
};
export { actions };

// REDUCER
const initialState = {
  data: [],
  dataById: {},
  loaded: false,
  loading: false,
  errorMessage: '',
  submitting: false
};

export default reducerFactory(PRODUCT_RAW_MATERIAL, initialState);

// SAGAS
const sagas = sagasFactory(PRODUCT_RAW_MATERIAL, '/produto_mp/');
export { sagas };
